import { fetcher } from "@/utils/api"
import { queryClient } from "pages/_app"

export const useMarkNotificationAsRead = () => {
  return async (uid: string) => {
    try {
      await fetcher(`/notifications/v2/${uid}/read`, {
        method: "PUT",
      })
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
      })
    } catch (error) {
      console.log(error)
    }
  }
}
